import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import HoverTooltip from "../../../common_components/hoverOverlay/HoverTooltip";
import { NETWORK_ICON_MAP } from "../utils/constants";
import { NETWORK_LABEL_MAP } from "../../../utils/networkConstants";
export const PlatformBadge = React.memo(({ platform }) => {
    const platforms = platform
        ? Array.from(new Set(platform.split(",").map(p => p.trim().toLowerCase()).filter(Boolean)))
        : [];
    if (platforms.length === 0)
        return null;
    const visiblePlatforms = platforms.slice(0, 3);
    const remainingPlatforms = platforms.slice(3);
    const getLabel = (p) => NETWORK_LABEL_MAP[p] || (p.charAt(0).toUpperCase() + p.slice(1));
    const remainingTooltipContent = remainingPlatforms.length > 0 ? (_jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 0.75, py: 0.5, px: 0.5 }, children: remainingPlatforms.map((p, idx) => {
            const icon = NETWORK_ICON_MAP[p];
            const label = getLabel(p);
            return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1, fontSize: 12, color: "#ffffff" }, children: [icon ? (_jsx("img", { src: icon, alt: label, style: { width: 14, height: 14, objectFit: "contain" }, onError: (e) => { e.target.style.display = "none"; } })) : (_jsx(Box, { sx: { width: 6, height: 6, borderRadius: "50%", bgcolor: "#9ca3af" } })), _jsx("span", { children: label })] }, idx));
        }) })) : null;
    return (_jsxs(Box, { sx: { display: "flex", gap: 0.5, alignItems: "center", flexWrap: "nowrap" }, children: [visiblePlatforms.map((p, i) => {
                const icon = NETWORK_ICON_MAP[p];
                const label = getLabel(p);
                return icon ? (_jsx(HoverTooltip, { title: label, placement: "top", children: _jsx("img", { src: icon, alt: label, style: { width: 20, height: 20, objectFit: "contain" }, onError: (e) => { e.target.style.display = "none"; } }) }, i)) : (_jsx(Box, { sx: {
                        fontSize: 10,
                        bgcolor: "#f4f4f5",
                        borderRadius: "4px",
                        px: 0.8,
                        py: 0.2,
                        color: "#52525b",
                        fontWeight: 600
                    }, children: label }, i));
            }), remainingPlatforms.length > 0 && (_jsx(HoverTooltip, { title: remainingTooltipContent, placement: "top", children: _jsxs(Box, { sx: {
                        fontSize: 10,
                        fontWeight: 600,
                        bgcolor: "#f4f4f5",
                        color: "#52525b",
                        borderRadius: "11px",
                        minWidth: 22,
                        height: 22,
                        px: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        border: "1px solid #e4e4e7",
                        transition: "all 0.15s ease",
                        "&:hover": {
                            bgcolor: "#e4e4e7",
                            color: "#18181b",
                            borderColor: "#d4d4d8"
                        }
                    }, children: ["+", remainingPlatforms.length] }) }))] }));
});
